'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import { useLocale } from '@src/i18n/LocaleProvider';
import { cn } from '@src/utils/tailwind';
interface CarouselBottomArrowsProps {
  desktopVisible: boolean;
  mobileVisible: boolean;
  previousSlide: (args: any) => void;
  nextSlide: (args: any) => void;
}
export const CarouselBottomArrows = t0 => {
  const $ = _c(27);
  const {
    desktopVisible,
    mobileVisible,
    previousSlide,
    nextSlide
  } = t0;
  const {
    t
  } = useLocale("carousel");
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== desktopVisible || $[1] !== mobileVisible || $[2] !== nextSlide || $[3] !== previousSlide || $[4] !== t) {
    const commonStyles = ["flex items-center justify-center bg-white flex shrink-0 rounded-full size-10 shadow-[0px_1px_3px_0px_#16181940] transition-all hover:bg-bodi-gray-pearl"];
    if ($[10] !== desktopVisible || $[11] !== mobileVisible) {
      t4 = cn("mt-4 hidden items-center justify-center gap-2", {
        flex: mobileVisible,
        "lg:flex": desktopVisible
      });
      $[10] = desktopVisible;
      $[11] = mobileVisible;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    let t6;
    if ($[13] !== t) {
      t6 = t("previous-slide");
      $[13] = t;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    let t7;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <ChevronLeftIcon className="size-6" />;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    t5 = <button onClick={previousSlide} aria-label={t6} className={cn(commonStyles)}>{t7}</button>;
    t1 = nextSlide;
    if ($[16] !== t) {
      t2 = t("next-slide");
      $[16] = t;
      $[17] = t2;
    } else {
      t2 = $[17];
    }
    t3 = cn(commonStyles);
    $[0] = desktopVisible;
    $[1] = mobileVisible;
    $[2] = nextSlide;
    $[3] = previousSlide;
    $[4] = t;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ChevronRightIcon className="size-6" />;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t1 || $[20] !== t2 || $[21] !== t3) {
    t7 = <button onClick={t1} aria-label={t2} className={t3}>{t6}</button>;
    $[19] = t1;
    $[20] = t2;
    $[21] = t3;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t4 || $[24] !== t5 || $[25] !== t7) {
    t8 = <div className={t4}>{t5}{t7}</div>;
    $[23] = t4;
    $[24] = t5;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
};